module.exports = __webpack_public_path__ + "img/new_learning.9a263ead.svg";